import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {HttpClientModule} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashAdminComponent } from './directory/dash-admin/dash-admin.component';
import { SigninComponent } from './signin/signin.component';
import { EquipeComponent } from './directory/users/equipe/equipe.component';
import { NewVisitComponent } from './directory/new-visit/new-visit.component';
import { VisitesComponent } from './directory/visites/visites.component';
import { VisiteComponent } from './directory/visite/visite.component';
import { DashCommercialComponent } from './dash-commercial/dash-commercial.component';
import { PlanifierComponent } from './planifier/planifier.component';
import { DeplacementComponent } from './deplacement/deplacement.component';
import { ProfilComponent } from './profil/profil.component';
import { CustomersComponent } from './customers/customers.component';
import { ActionsComponent } from './actions/actions.component';
import { ConfigComponent } from './config/config.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ReferentialComponent } from './directory/referential/referential.component';
import { FilterPipe } from './rest_services/filter.pipe';
import { MyCustomersComponent } from './my-customers/my-customers.component';
import { UsersComponent } from './directory/users/users.component';
import { RolesComponent } from './directory/users/roles/roles.component';
import { ProfilesComponent } from './directory/users/profiles/profiles.component';
import { UserListComponent } from './directory/users/user-list/user-list.component';
import { StatisticsComponent } from './directory/statistics/statistics.component';
import { CoverPageComponent } from './cover-page/cover-page.component';
import { StatisticsCustomersComponent } from './directory/statistics-customers/statistics-customers.component';
import { AdminSpaceComponent } from './admin-space/admin-space.component';
import { NewCustomerComponent } from './directory/new-customer/new-customer.component';
import { EditCustomerComponent } from './directory/edit-customer/edit-customer.component';
import { CustomerComponent } from './directory/customer/customer.component';
import { NewProfilComponent } from './directory/new-profil/new-profil.component';
import { ContactComponent } from './contact/contact.component';
import { NewContactComponent } from './directory/new-contact/new-contact.component';
import { FicheContactComponent } from './directory/fiche-contact/fiche-contact.component';
import { EditContactComponent } from './directory/edit-contact/edit-contact.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { environment } from '../environments/environment.prod';
import { AbsenceComponent } from './absence/absence.component';
import { AbsenceRequestComponent } from './directory/absence-request/absence-request.component';
import { SupportComponent } from './support/support.component';
import { SupportReqComponent } from './directory/support-req/support-req.component';
import { CompleteVisitComponent } from './directory/complete-visit/complete-visit.component';
import { DashSupportComponent } from './dash-support/dash-support.component';
import { SatisfactionRequestComponent } from './surveys-list/surveys-list.component';
import { SurveyDetailComponent } from './directory/survey-detail/survey-detail.component';
import { SatisfactionSurveyComponent } from './satisfaction-survey/satisfaction-survey.component';
import { AbsenceUpdateComponent } from './directory/absence-update/absence-update.component';
import { AbsenceDetailComponent } from './directory/absence-detail/absence-detail.component';
import { MessagerieComponent } from './directory/messagerie/messagerie.component';
import { SupportTicketComponent } from './directory/support-ticket/support-ticket.component';
import { SupportDetailComponent } from './directory/support-detail/support-detail.component';
import { SupportSurveyComponent } from './directory/support-survey/support-survey.component';
import { ContactUsComponent } from './landingPage/contact-us/contact-us.component';
import { IndexComponent } from './landingPage/landing_index/index.component';
import { LandingMasterComponent } from './landingPage/landing_master/landing-master.component';
import { ScriptLoaderService } from './rest_services/script-loader.service';
import { FunctionalitiesComponent } from './landingPage/functionalities/functionalities.component';
import { CommonModule } from '@angular/common';
import { PublicPageGuard } from './guards/public-page.guard';
import { NavigationService } from './rest_services/navigation.service';
import { AuditComponent } from './audit/audit.component';


@NgModule({
  declarations: [
    AppComponent,
    DashAdminComponent,
    SigninComponent,
    EquipeComponent,
    NewVisitComponent,
    VisiteComponent,
    VisitesComponent,
    DashCommercialComponent,
    PlanifierComponent,
    DeplacementComponent,
    ProfilComponent,
    CustomersComponent,
    ActionsComponent,
    ConfigComponent,
    DashboardComponent,
    ReferentialComponent,
    FilterPipe,
    MyCustomersComponent,
    UsersComponent,
    RolesComponent,
    ProfilesComponent,
    UserListComponent,
    StatisticsComponent,
    CoverPageComponent,
    StatisticsCustomersComponent,
    AdminSpaceComponent,
    NewCustomerComponent,
    EditCustomerComponent,
    CustomerComponent,
    NewProfilComponent,
    ContactComponent,
    NewContactComponent,
    FicheContactComponent,
    EditContactComponent,
    AbsenceComponent,
    AbsenceRequestComponent,
    SupportComponent,
    SupportReqComponent,
    CompleteVisitComponent,
    DashSupportComponent,
    SatisfactionRequestComponent,
    SurveyDetailComponent,
    SatisfactionSurveyComponent,
    AbsenceUpdateComponent,
    AbsenceDetailComponent,
    MessagerieComponent,
    SupportTicketComponent,
    SupportDetailComponent,
    SupportSurveyComponent,
    IndexComponent,
    ContactUsComponent,
    LandingMasterComponent,
    FunctionalitiesComponent,
    AuditComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    RecaptchaV3Module,
    CommonModule,
  ],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
    },
    ScriptLoaderService,
    PublicPageGuard,
    NavigationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
